import { DeliveryStatus } from '@/useDelivery';
import { DeliveryNoteStatus } from '@/useDeliveryNote';

interface DeliveryCounter {
  status: DeliveryStatus;
  count: number;
  weight: number;
}

interface DeliveryNoteCounter {
  status: DeliveryNoteStatus;
  count: number;
  weight: number;
}

const DEFAULT_COUNT_DELIVERY = [
  { status: 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER', count: 0, weight: 0 },
  { status: 'PREPARE_TO_DELIVER', count: 0, weight: 0 },
  { status: 'ON_THE_WAY', count: 0, weight: 0 },
  { status: 'HUB', count: 0, weight: 0 },
  { status: 'SUCCESS', count: 0, weight: 0 },
  { status: 'SOME_SUCCESS', count: 0, weight: 0 },
  { status: 'NOT_SUCCESS', count: 0, weight: 0 },
];

const DEFAULT_COUNT_DELIVERY_NOTE = [
  { status: 'PREPARE_TO_DELIVER', count: 0, weight: 0 },
  { status: 'ON_THE_WAY', count: 0, weight: 0 },
  { status: 'SUCCESS', count: 0, weight: 0 },
  { status: 'SOME_SUCCESS', count: 0, weight: 0 },
  { status: 'NOT_SUCCESS', count: 0, weight: 0 },
];

export function deliveryStatsMapper(todayStats: DeliveryCounter[], accumulateStats: DeliveryCounter[]) {
  const result = [...DEFAULT_COUNT_DELIVERY];
  const counter = todayStats || [...DEFAULT_COUNT_DELIVERY];
  const accumulateCounter = accumulateStats || [...DEFAULT_COUNT_DELIVERY];

  result[0] = counter.find((countObj: any) => countObj.status === 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER') || DEFAULT_COUNT_DELIVERY[0];
  result[1] = counter.find((countObj: any) => countObj.status === 'PREPARE_TO_DELIVER') || DEFAULT_COUNT_DELIVERY[1];
  result[2] = counter.find((countObj: any) => countObj.status === 'ON_THE_WAY') || DEFAULT_COUNT_DELIVERY[2];
  result[3] = counter.find((countObj: any) => countObj.status === 'HUB') || DEFAULT_COUNT_DELIVERY[3];
  result[5] = counter.find((countObj: any) => countObj.status === 'SOME_SUCCESS') || DEFAULT_COUNT_DELIVERY[5];
  result[6] = counter.find((countObj: any) => countObj.status === 'NOT_SUCCESS') || DEFAULT_COUNT_DELIVERY[6];
  result[4] = accumulateCounter.find((countObj: any) => countObj.status === 'SUCCESS') || DEFAULT_COUNT_DELIVERY[4];

  return result;
}

export function deliveryNoteStatsMapper(todayStats: DeliveryNoteCounter[], accumulateStats: DeliveryNoteCounter[]) {
  const result = [...DEFAULT_COUNT_DELIVERY_NOTE];
  const counter = todayStats || [...DEFAULT_COUNT_DELIVERY_NOTE];
  const accumulateCounter = accumulateStats || [...DEFAULT_COUNT_DELIVERY_NOTE];

  result[0] = counter.find((countObj: any) => countObj.status === 'PREPARE_TO_DELIVER') || DEFAULT_COUNT_DELIVERY_NOTE[0];
  result[1] = counter.find((countObj: any) => countObj.status === 'ON_THE_WAY') || DEFAULT_COUNT_DELIVERY_NOTE[1];
  result[3] = counter.find((countObj: any) => countObj.status === 'SOME_SUCCESS') || DEFAULT_COUNT_DELIVERY_NOTE[3];
  result[4] = counter.find((countObj: any) => countObj.status === 'NOT_SUCCESS') || DEFAULT_COUNT_DELIVERY_NOTE[4];
  result[2] = accumulateCounter.find((countObj: any) => countObj.status === 'SUCCESS') || DEFAULT_COUNT_DELIVERY_NOTE[2];

  return result;
}
